export default "__VITE_ASSET__DjsjZoHx__"